import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-20 bg-primary-800 text-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-500 flex items-center justify-center">
                <i className="ri-clapperboard-line text-background-50 text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">出轨的妻子</span>
            </div>
            <p className="text-sm leading-7 text-background-200/80 max-w-md">
              专注「出轨的妻子」题材的情感类影视专题站，提供电影与电视剧的剧情介绍、角色关系分析、专家影评与专题策划，帮助观众更深入地理解剧情发展与人物关系。
            </p>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">站点导航</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/" className="text-background-200/80 hover:text-background-50 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category" className="text-background-200/80 hover:text-background-50 transition-colors cursor-pointer">影视分类</Link></li>
              <li><Link to="/special" className="text-background-200/80 hover:text-background-50 transition-colors cursor-pointer">影评专题</Link></li>
              <li><Link to="/search" className="text-background-200/80 hover:text-background-50 transition-colors cursor-pointer">搜索</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">关于本站</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/about" className="text-background-200/80 hover:text-background-50 transition-colors cursor-pointer">网站定位</Link></li>
              <li><Link to="/about" className="text-background-200/80 hover:text-background-50 transition-colors cursor-pointer">版权声明</Link></li>
              <li><Link to="/contact" className="text-background-200/80 hover:text-background-50 transition-colors cursor-pointer">联系我们</Link></li>
              <li><span className="text-background-200/60">联系邮箱：contact@chuguideqizi.com</span></li>
            </ul>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-200/60">
          <p>© {year} 出轨的妻子 · 影视资料站 版权所有</p>
          <p>本站内容均为虚构示范，仅供影视交流与学习使用</p>
        </div>
      </div>
    </footer>
  );
}